<template>
    <v-card class="elevation-1">
        <v-toolbar flat color="grey lighten-4 pt-1">
            <v-toolbar-title class="grey--text text--darken-4">{{ title }}</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider></v-divider>

        <v-data-table v-if="infoData.modelDef"
            :pagination.sync="pagination"
            :headers="fieldDefs"
            :items="items"
            v-model="selected"
			:loading="loading"
            :rows-per-page-items="[10, 25, 50,  { text: 'Tutti', value: -1 }]"
            select-all
            >
            <template slot="headers" slot-scope="props">
                <tr>
                    <th style="width: 50px">
                        <v-checkbox
                            color="primary"
                            @click.native="toggleAll"
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            hide-details
                        ></v-checkbox>
                    </th>
                    <th 
                        v-for="header in props.headers" 
                        :key="header.text"
                        :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                        @click="changeSort(header)">
						<span>
							{{ header.text }}
						</span>
                        <v-icon>arrow_upward</v-icon>
                    </th>
                </tr>
            </template>

            <template slot="items" slot-scope="props">
                <tr class="cursor-pointer">
                    <td>
                        <v-checkbox
                            color="primary"
                            v-model="props.selected"
                            hide-details
                        ></v-checkbox>
                    </td>
                    <template v-for="(header, k) in fieldDefs">
                        <td v-if="header.value === 'actions'" :class="'text-xs-'+(header.align?header.align:'left')" :style="'width: ' + (header.width ? header.width : '')" :key="k">
                            <v-btn icon class="mx-0" @click.stop="openEdit(props.item)">
                                <v-icon color="primary">edit</v-icon>
                            </v-btn>
                        </td>
                        <td v-else-if="header.value === 'number'" :class="'text-xs-'+header.align" style="width: 40px" :key="k">
                            {{ props.index + 1 }}
                        </td>
						<td v-else-if="header.type === 'movement_type'" :key="k"
							@click="openShow(props.item)">
							<div :class="$eventBusUtility.movementColor(props.item.type)">
								{{ props.item[header.value] }}
							</div>
						</td>
                        <td v-else :key="k" :style="'width: ' + (header.width ? header.width : '')"
                            @click="openEdit(props.item)">
                            {{ props.item[header.value] }}
                        </td>
                    </template>
                </tr>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                <div class="primary--text"><span class="primary--text">{{ countSelected }}</span> Selezionati</div>
                Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
            </template>

        </v-data-table>

        <component 
            :is="footerComponent"
            :items="items"
            :info="infoData"
        ></component>

        <v-card-text style="position: relative">
            <slot name="actions">
                <v-speed-dial
                    v-model="fab"
                    :fixed="actionPositionFixed"
                    :absolute="actionPositionAbsolute"
                    bottom
                    :left="positionLeft"
                    :right="positionRight"
                    :direction="direction"
                    transition="scale-transition">
                    <v-btn
                        slot="activator"
                        color="primary"
                        dark
                        fab
                        v-model="fab">
                        <v-icon>{{ actionIcon }}</v-icon>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-tooltip top>
                        <v-btn
                            fab
                            dark
                            small
                            color="indigo"
                            slot="activator"
                            @click.native.stop="showDialog = true">
                            <v-icon>add</v-icon>
                        </v-btn>
                        <span>Nuovo</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn
                            fab
                            dark
                            small
                            color="red"
                            slot="activator"
                            :disabled="disabled"
                            @click.native.stop="confirmDelete = true">
                            <v-icon>delete</v-icon>
                        </v-btn>
                        <span>Elimina</span>
                    </v-tooltip>
                </v-speed-dial>
            </slot>

        </v-card-text>

        <confirm-dialog
			:confirmModel="confirmDelete"
			mainTitle="Eliminare gli elementi selezionati?"
			secondTitle="Gli elementi selezionati verranno eliminati solamente se indipendenti e non collegati a nessun altra entità. Una volta eliminati non sarà possibile ripristinarli"
			@update:confirmModel="confirmDelete = false"
			:atConfirm="deleteModels"
			:confirm="{label:'Procedi', color:'red'}"
        ></confirm-dialog>

        <v-dialog v-model="showDialog"
            max-width="800px"
            persistent lazy
            :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card>
                <v-toolbar flat color="grey lighten-4">
                    <v-toolbar-title class="pl-3 grey--text text--darken-4">
                        {{ title }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                    <v-container fluid pa-2>
                        <fields-generator
                            :layoutClass="['row','wrap']" 
                            :fieldsset.sync="fieldsset"
                            :model="model"
                            ref="fieldsgenerator"
                        ></fields-generator>
                        <small class="pl-4">* Indica i campi obbligatori</small>
                    </v-container>
                </v-card-text>
                <v-card-actions class="px-2">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native.stop="closeDialog()">Chiudi</v-btn>
                    <v-btn color="primary" flat @click.native="storeModel()">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-card>
</template>

<script>

import Vue from 'vue'
import FieldsGenerator from '@/components/FieldsGenerator'
import DataTableMixin from '@/mixins/DataTableMixin.js'
import ResumeFooter from '@/components/fidelitycard/ResumeFooter'

export default {
	name: 'has-many-crud',
	components: {
		FieldsGenerator,
		/* eslint-disable vue/no-unused-components */
		ResumeFooter
	},
	mixins: [DataTableMixin],
	props: {
		title: String,
		actionIcon: String,
		modelDef: String,
		subFilters: String,
		subFiltersId: Number,
		actionPosition: String,
		defaultInput: Object,
		redirect: Object,
		// eslint-disable-next-line
		loading: false,
		footerComponent: String,
		speedDialOptions: Object,
		positionRight: {
			type: Boolean,
			default: true
		},
		positionLeft: {
			type: Boolean,
			default: false
		},
		direction: {
			type: String,
			default: 'left'
		}
	},

	data() {
		return {
			confirmDelete: false,
			disabled: true,
			fab: false,
			infoData: {},
			showDialog: false,
			selected: [],
			items: [],
			pagination: {},
			totalItems: 0,
			fieldsset: {},
			model: { [this.subFilters]: this.subFiltersId },
			defaultModel: { [this.subFilters]: this.subFiltersId }
		}
	},

	mounted() {
		this.$eventBusUtility.$on('refreshTable', modelDef => {
			this.getDataFromApi()
		})
	},

	methods: {
		getDataFromApi() {
			this.loading = 'primary'
			this.axios
				.post(this.modelDef + '-filters', {
					subFilters: { [this.subFilters]: this.subFiltersId }
				})
				.then(response => {
					// get body data
					this.items = response.data.data.data
					this.totalItems = this.items.length
					this.loading = false
				},
				response => {
					// error callback
				})
		},

		openEdit(item) {
			this.model = Object.assign(this.model, item)
			this.showDialog = true
		},

		storeModel() {
			this.$refs.fieldsgenerator.$validator
				.validateAll()
				.then(result => {
					if (!result) {
						return false
					}

					if (_.has(this.model, 'id')) {
						this.axios
							.put(this.modelDef + '/' + this.model.id, this.model)
							.then(response => {
								// get body data
								this.getDataFromApi()
								this.closeDialog()
								this.$eventBusUtility.$emit('refreshParentModel')

								// Got in show
							},
							response => {
								// error callback
							})
					} else {
						this.axios.post(this.modelDef + '/', this.model).then(response => {
							// get body data
							this.getDataFromApi()
							this.closeDialog()
							this.$eventBusUtility.$emit('refreshParentModel')
							// Got in show
						},
						response => {
							// error callback
						})
					}
				})
				.catch(() => {})
		},

		closeDialog() {
			this.showDialog = false
			this.model = {}
			Object.assign(this.model, this.defaultModel)
		},

		deleteModels() {
			let ids = []
			this.selected.forEach(function(element, i) {
				ids[i] = element.id
			})

			this.axios.post(this.modelDef + '/delete', { ids: ids }).then(response => {
				// get body data
				let data = response.data
				this.disabled = true
				this.selected = []
				this.getDataFromApi()
				this.confirmDelete = false
				let snackmessage = ''
				let snackcolor = ''
				if (data.status == 'message') {
					snackmessage = data.message
					snackcolor = data.type
				} else {
					snackmessage = 'Elementi eliminati con successo.'
					snackcolor = 'success'
				}
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: snackmessage,
					value: true,
					color: 'success'
				})

				this.$eventBusUtility.$emit('refreshParentModel')
			},
			response => {
				// error callback
			})
		}
	},

	created() {
		// Get info data for model
		this.loading = true
		this.axios.get(this.modelDef + '-info/').then(response => {
			// get info data
			this.infoData = response.data.info
			this.fieldsset = response.data.fields
			_.forEach(this.fieldsset.fields, (value, key) => {
				if (value.default) {
					Vue.set(this.model, value.key, value.default)
				}
			})
				
			this.getDataFromApi()
			this.$store.commit('endProgress')
		},
		response => {
			// error callback
			this.loading = false
		})
	}
}
</script>
